import { render, staticRenderFns } from "./RealTimeAlarm.vue?vue&type=template&id=c1f95876&scoped=true"
import script from "./RealTimeAlarm.vue?vue&type=script&lang=js"
export * from "./RealTimeAlarm.vue?vue&type=script&lang=js"
import style0 from "./RealTimeAlarm.vue?vue&type=style&index=0&id=c1f95876&prod&lang=scss"
import style1 from "./RealTimeAlarm.vue?vue&type=style&index=1&id=c1f95876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f95876",
  null
  
)

export default component.exports